import { ParsedPresignParams, PresignAction } from '../config';

import { hasAllRequiredPresignParams } from './hasAllRequiredPresignParams';
import { parsePresignParams } from './parsePresignParams';

type DecidePresignActionArgs = {
  currentParams: ParsedPresignParams;
  currentUserID: string;
  storedUrl: string | null;
};

const identityMatches = (
  stored: ParsedPresignParams,
  current: ParsedPresignParams,
): boolean => {
  const userIDMatch = stored.required.userID === current.required.userID;
  const organizationIDMatch =
    !current.optional.organizationID ||
    stored.optional.organizationID === current.optional.organizationID;
  const reportIDMatch =
    !current.optional.reportID ||
    stored.optional.reportID === current.optional.reportID;

  return userIDMatch && organizationIDMatch && reportIDMatch;
};

export const decidePresignAction = ({
  currentParams,
  currentUserID,
  storedUrl,
}: DecidePresignActionArgs): PresignAction => {
  if (!hasAllRequiredPresignParams(currentParams.required)) {
    return { type: 'noop' };
  }

  if (storedUrl) {
    try {
      const storedParams = parsePresignParams(new URL(storedUrl).searchParams);

      return identityMatches(storedParams, currentParams)
        ? { type: 'noop' }
        : { type: 'reauthenticate', params: currentParams };
    } catch {
      // Unparseable stored url — ignore it.
    }
  }

  return currentParams.required.userID === currentUserID
    ? { type: 'store' }
    : { type: 'reauthenticate', params: currentParams };
};
